module.exports = __webpack_public_path__ + "static/media/tax-consulting-category-top-banner.fc651023.jpg";